import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment-timezone';
import {Button} from "antd"
import ButtonComp from "../ButtonComp/ButtonComp";

const LineLevelBoardTableTwo = ({ data, isFullScreen, toggleFullScreen }) => {
  
  const { current } = useSelector((state) => state?.plant);
  const { plant } = useSelector(state => state?.plant?.current)
  const { stats } = useSelector((state) => state.kpis);
  
  return (
    <div className="custom-table">
      <table className="lineTable">
        <thead>
          <tr className="table-row">
            <th className="table-cell" colSpan="7" >Hourly Production Line Level Board 
          <Button className={isFullScreen ? "llbBtnExit" : "llbBtnEnter"} onClick={toggleFullScreen}
          >{isFullScreen ? "Exit" : "Full Screen"}
        </Button>
                    </th>
          </tr>
        </thead>
        <tbody>
          <tr className="table-row">
            <th className="table-cell">Last Update: {moment(stats?.updated_at).format('h:mm:ss a')}</th>
            <th className="table-cell">Shift: {current?.shift?.name}</th>
            <th colSpan="4" className="table-cell">Product: {current?.shift?.product?.name}</th>
          </tr>
          <tr className="table-row">
            <th className="table-cell">Time</th>
            <th className="table-cell">Hourly Target</th>
            <th className="table-cell">Actual Output</th>
            <th className="table-cell">Revised Hourly Target</th>
            <th className="table-cell">Shortfall</th>
            <th className="table-cell">Target Status</th>
            {/* <th className="table-cell">Hourly OEE</th> */}
          </tr>
          {data &&
          data.map((each, index) => (
            <tr key={index} className={each.isCurrent? `table-row blinking-row` : ''}>
            <td className="table-cell">{each.Time}</td>
            <td className="table-cell">{typeof(each.target) == 'number' ?(each.target).toFixed(0):'N/A'}</td>
            <td className="table-cell">{each.Actual_Output}</td>
            <td className="table-cell">{typeof(each.revisedHourlyTarget) == 'number' ?(each.revisedHourlyTarget).toFixed(0):'N/A'}</td>
            <td className="table-cell">{typeof(each.shortFall) == 'number' ?(each.shortFall).toFixed(0):'N/A'}</td>
            <td className="table-cell" style={{color:'white',backgroundColor:each.shortFall?(each.shortFall<0?'red':'green'):'black'}}>{(each.shortFall>0)?'Target Achieved':(each.shortFall<0)?'Target Missed':'N/A'}</td>
            {
              //<td style={{color:'white',backgroundColor:each.shortFall?(each.shortFall<0?'red':'green'):'black'}}>{typeof each.Oee == 'number'?each.Oee && each.shortFall?(each.Oee +'%'):'N/A':'N/A'}</td>
            }
          </tr>
        ))
 
        }
        </tbody>
      </table>
    </div>
  );
};

export default LineLevelBoardTableTwo;
